import {
  ActionReducerMapBuilder,
  EntityState,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';

import { AppError } from '@vk-hr-tek/core/error';

import { ThunkExtra } from '@app/store';
import {
  DashboardService,
  GetUserWidgetTopNewsResponse,
  GetUserWidgetTopNewsParams,
} from '@app/gen/dashboard';
import { DynamicEntity } from '@app/types';

import { DashboardState } from '../dashboard.state';

export const getTopNews = createAsyncThunk<
  GetUserWidgetTopNewsResponse['top_news'],
  GetUserWidgetTopNewsParams,
  ThunkExtra
>(
  'dashboard/getTopNews',
  async (params, { rejectWithValue, extra: { inject } }) => {
    try {
      const result = await inject(DashboardService).getUserWidgetTopNews({
        params,
      });

      return result.top_news;
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const topNewsReducers = (
  builder: ActionReducerMapBuilder<
    EntityState<DynamicEntity, string> & DashboardState
  >,
) => {
  builder.addCase(getTopNews.pending, (state) => {
    state.topNews.status = 'loading';
  });
  builder.addCase(getTopNews.fulfilled, (state, { payload }) => {
    state.topNews.status = 'complete';
    state.topNews.items = payload;
  });
  builder.addCase(getTopNews.rejected, (state) => {
    state.topNews.status = 'failed';
  });
};
